import React from "react";
import LoginComponent from "../components/LoginComponent";

const LoginContainer = () => {
  return <LoginComponent />;
};

export default LoginContainer;